/*global window, _, MOVE_DATA, localStorage, JST */

export const fadeInOutAnimation = function (headLines, headlineSpan) {
  var headlineCycleFadeIn,
      rotationCounter = 0,
      curHeadline = 0;
  var headlineCycleFadeOut = function () {
    headlineSpan.fadeOut(2000, function () {
      curHeadline++;
      if (curHeadline < headLines.length) {
        headlineSpan.html(headLines[curHeadline]);
        headlineCycleFadeIn();
      }
      else {
        if (rotationCounter === headLines.length) {
          headlineSpan.html(headLines[0]);
          headlineSpan.fadeIn(2000);
        }
        else {
          rotationCounter++;
          curHeadline = -1;
          headlineCycleFadeOut();
        }
      }
    });
  };
  headlineCycleFadeIn = function headlineCycleFadeIn() {
    headlineSpan.fadeIn(2000, function () {
      headlineCycleFadeOut();
    });
  };
  if (headLines) {
    headlineCycleFadeOut();
  }

};
// General popover javascript for HTML content popovers
export const initPopOver = function (form, container) {
  form.find('[rel="popover"]').popover({
    container: container || 'body',
    html: true,
    trigger: 'click',
    clickAutoClose: true,
    content: function () {
      var clone = $($(this).data('popover-content')).clone(true).removeClass('hide');
      return clone;
    }
  }).click(function (e) {
    e.preventDefault();
  });
};


export const closePopOver = function closePopOver(form) {
  var $popOver = form.find('[rel="popover"]');
  if ($popOver.length > 0) {
    $popOver.popover('hide');
  }
};

export const closePopOversOnResize = function () {
  closePopOver($("#ldp-listing-provider"));
  closePopOver($("#ldp-additional-info"));
  closePopOver($("#ldp-pricewrap"));
  closePopOver($("#market-summary-data"));
  closePopOver($("#footer"));
  closePopOver($("#summary-pg-price-section"));
  closePopOver($("#ldp-home-advisor-widget"));
  closePopOver($("#veteran-popover-content"));
  closePopOver($("#mortgage_calculator_form"));
  closePopOver($("#estimate-commute-time-popover"));
  closePopOver($("#MortgageLegendList"));
  closePopOver($("#ldp-homes-with-similar-mortgage"));
};

// Pop over on hover for desktop and click on mobile
var initPopOverHover = function ($section) {
  var $popoverCta = $section.find('[rel="popover-hover"]');
  var trigger =
      MOVE.Helper.isMobile() ||
      MOVE.Helper.isMobileDevice() ||
      MOVE.Helper.detectViewPort() === 'small';

  $popoverCta.popover({
    container: 'body',
    html: true,
    trigger: trigger ? 'click' : 'hover',
    clickAutoClose: true,
    content: function () {
      return $($(this).data('popover-content')).clone(true).removeClass('hide');
    }
  });

  // Bind body click/touch event so the popover would close if user clicks outside popover
  if (trigger) {
    $('body').on('click touchstart', function (e) {
      var $target = $(e.target);
      if (!$target.is($popoverCta) && ($target.parents('[rel="popover-hover"]').length === 0) && ($popoverCta.length > 0)) {
        $popoverCta.popover('hide');
      }
    });
  }
};

// Closing function popOverHover
export const closePopOverHover = function closePopOverHover($section) {
  var $popOverHover = $section.find('[rel="popover-hover"]');
  if ($popOverHover.length > 0) {
    $popOverHover.popover('hide');
  }
};

/**
 *
 * @param target : selector of images to be lazy loaded
 * @param options: extra option for lazy loading https://github.com/ressio/lazy-load-xt/#options
 * @param container: parent tag where all the images to be lazy loaded// (optional)
 */
export const unveilLoadImages = function (target, options, $container, callback) {
  $(document).ready(function() {
    $(target).filter(":not(.owl-lazy)").unveil(800, $container, callback);
    // 800px before they appear on the screen
  });
};

/**
 *
 * @param target : selector of images to be lazy loaded
 * @param container: parent tag where all the content to be lazy loaded (optional)
 * @param threshold: px before they appear on the screen (optional)
 * @param callback: callback function after trigger content unveil (optional)
 */
export const unveilLoadContent = function ($target, $container, threshold, callback) {
  var th = threshold || 800;
  $target.unveil(th, $container, callback);
};

/*
  switch (MOVE.DOMHelper.detectPageType()) {
  case 'srp':
  //srp code
  break;
  case 'ldp':
  //lcdp code
  break;
  case 'hp':
  //homepage code
  break;
  default:
  break;
  }
*/
export const detectPageType = function () {
  return MOVE.DataStore.getData('pageType');
};

export const appendLoading = function ($target) {
  $target.append(MOVE.CONSTANTS.LOADING_ICON);
};

export const prependLoading = function ($target) {
  $target.prepend(MOVE.CONSTANTS.LOADING_ICON);
};

export const removeLoading = function ($target) {
  $target.find('.' + MOVE.CONSTANTS.LOADING_ICON_CLASS).remove();
};

// Find current page on click by finding closest page anchor below click.
export const findPropertyPage = function ($dom, clickPos) {
  var anchorPosition = 99999, anchor;
  _.each($dom.toArray(), function (i) {
    var currentDomAnchor = $(i).offset().top - clickPos;
    if (currentDomAnchor < anchorPosition && currentDomAnchor > 0) {
      anchorPosition = currentDomAnchor;
      anchor = i;
    }
  });
  return anchor;
};

export const findNearestDomFromScroll = function ($dom) {
  return _.find($dom.toArray(), function (i) {
    var position = $(i).position().top - $(window).scrollTop();
    if (position <= 1000) {
      return false;
    } else {
      return true;
    }
  });
};

export const asyncTracking = function (url) {
  var lib = document.createElement('script');
  lib.async = true;
  lib.type = "text/javascript";
  lib.src = url;
  var node = document.getElementsByTagName("script")[0];
  node.parentNode.insertBefore(lib, node);
};

export const loadAsyncLib = function (url, callback) {
  var lib = document.createElement('script');
  lib.async = true;
  lib.type = "text/javascript";
  var useSSL = "https:" === document.location.protocol;
  if (callback) {
    lib.onload = lib.onreadystatechange = function() {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        callback();
      }
    };
  }
  lib.src = (useSSL ? "https:" : "http:") + url;
  var node = document.getElementsByTagName("script")[0];
  node.parentNode.insertBefore(lib, node);
};

//highlight and jump to the selected thumbnail.
export const highlightThumbnail = function(index, $thumbnails) {
  if ($thumbnails) {
    var curThumbnail = $thumbnails.find("div.owl-item:not('.clone')").eq(index);
    if (!curThumbnail.hasClass("highlight")) {
      $thumbnails.find("div.highlight").removeClass("highlight");
      $thumbnails.trigger("to.owl.carousel", [index, 200, true]);
      curThumbnail.addClass("highlight");
    }
  }
};

export const getUrlParts = function () {
  return _.chain(location.pathname.split('/'))
    .compact()
    .value();
};

// returns false when user enters anything other than numbers
// Key codes
// 8  : Backspace
// 48 : Number zero
// 57 : Number nine
export const validatePhone = function (e) {
  if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
};


export const getPageNumber = function () {
  var pageNumber = _.find(getUrlParts(), function (i) {
    return i.indexOf('pg-') >= 0;
  });
  if (pageNumber) {
    return parseInt(pageNumber.split('-')[1], 10);
  }
  else {
    return false;
  }
};

export const loadCarouselThumbnails = function($thumbnails) {
  $thumbnails.owlCarousel({
    lazyLoad: true,
    margin: 10,
    nav: true,
    dots: false,
    responsiveClass:true,
    responsive:{
      767:{ items: 10 },
      820:{ items: 11 },
      930:{ items: 13 },
      1200:{ items: 15 },
      1400:{ items: 18 },
      1600:{ items: 21 }
    },
    navText: [
      "<div class='gallery-arrows arrow-left'><i class='ra ra-chevron-left'></i></div>",
      "<div class='gallery-arrows arrow-right'><i class='ra ra-chevron-right'></i></div>"
    ]
  });
};

export const movingQuoteErrorPlacement = function (error, $element) {
  if ($element.hasClass("date")) {
    $element.parent().after(error);
  } else {
    error.insertAfter($element);
  }
};

export const disableCrabwalk = function(){
  if(MOVE.LocalStorage.isAvailable) {
    window.localStorage.setItem('disable_crabwalk', 'true');
  }
};

export const enableCrabwalk = function(){
  if(MOVE.LocalStorage.isAvailable) {
    window.localStorage.setItem('disable_crabwalk', '');
  }
};

export const isCrabwalkDisable = function(){
  return MOVE.LocalStorage.isAvailable &&
    window.localStorage.getItem('disable_crabwalk') === 'true';
};

/**
   Set the default value on a Select picker.
*/
export const setSelectPickerDefaultValue = function (target, value) {
  if (value !== null) {
    $(target).selectpicker('val', value);
  }
};

export const getUrlParams = function () {
  return _.chain(location.search.slice(1).split('&'))
    .map(function (item) {
      if (item) {
        return item.split('=');
      }
    })
    .compact()
    .object()
    .value();
};


export const getUrlWithParams = function (url, params) {
  return url + '?' + $.param(params);
};


// Close Bootstrap tooltips on tap of page for iphone
export const closeTooltips = function () {
  if (navigator.userAgent.match(/iPhone/i)) {
    // Apply only when a tooltip is shown
    $('[data-toggle="tooltip"]').on("shown.bs.tooltip", function() {
      $('body').css('cursor', 'pointer');
    });

    // Return cursor to default value when tooltip hidden.
    $('[data-toggle="tooltip"]').on("hide.bs.tooltip", function() {
      $('body').css('cursor', 'auto');
    });
  }
};

MOVE.DOMHelper = {
  fadeInOutAnimation,
  initPopOver,
  initPopOverHover,
  closePopOversOnResize,
  closePopOverHover,
  unveilLoadImages,
  unveilLoadContent,
  appendLoading,
  prependLoading,
  removeLoading,
  findNearestDomFromScroll,
  findPropertyPage,
  detectPageType,
  loadAsyncLib,
  asyncTracking,
  getUrlParts,
  getUrlParams,
  getUrlWithParams,
  highlightThumbnail,
  loadCarouselThumbnails,
  movingQuoteErrorPlacement,
  disableCrabwalk,
  enableCrabwalk,
  isCrabwalkDisable,
  setSelectPickerDefaultValue,
  validatePhone,
  getPageNumber,
  closeTooltips
};

export const DOMHelper = MOVE.DOMHelper;



// WEBPACK FOOTER //
// ./shared_critical/dom_helper.js